import * as R from 'ramda';
import { AccountHierarchy } from 'types/api/AccountHierarchy';

export function sortByName(nodes: AccountHierarchy[]) {
  return R.sortBy(R.prop('name'), nodes);
}
